import { render, staticRenderFns } from "./GraphDetail09.vue?vue&type=template&id=2b985444&scoped=true&"
import script from "./GraphDetail09.vue?vue&type=script&lang=js&"
export * from "./GraphDetail09.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2b985444",
  null
  
)

export default component.exports